// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Libraries
import { withTranslation } from 'shared/utils/withTranslation'

// Components

// Shared
import { setFilterSortBy } from 'store/v2/redux/actions/filter'

export class SortingSelect extends Component {
  static displayName = 'SortingSelect'

  static propTypes = {
    sortBy: PropTypes.string,
    handleChangeSortBy: PropTypes.func,
    showPrices: PropTypes.bool,
    t: PropTypes.func,
    tOrEmptyString: PropTypes.func
  }

  get options () {
    const { showPrices, tOrEmptyString } = this.props

    let options = [
      {
        label: tOrEmptyString('user.store.sorting_standard'),
        value: 'null'
      }
    ]

    if (showPrices) {
      options.push(
        {
          label: tOrEmptyString('user.store.sorting_price_ascending'),
          value: 'price_each_in_cents'
        },
        {
          label: tOrEmptyString('user.store.sorting_price_descending'),
          value: '-price_each_in_cents'
        }
      )
    }

    options.push({
      label: tOrEmptyString('user.store.sorting_newest'),
      value: '-created_at'
    })

    return options
  }

  render () {
    const { sortBy, handleChangeSortBy } = this.props

    return (
      <div className="select-container bq-sorting-select">
        <select
          name="sort"
          className="bq-sort"
          onChange={handleChangeSortBy}
          value={sortBy}
        >
          {this.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const filter = state.filter.get(props.filterKey || 'global')
  const sortBy = (filter && filter.get('sort_by')) || undefined

  return {
    sortBy,
    showPrices: state.settings.get('store.use_prices')
  }
}

const mapDispatchToProps = (_dispatch, props) => {
  return {
    handleChangeSortBy: (event) => {
      let value = event.target.value

      if (value === 'null') {
        value = null
      }

      setFilterSortBy(value, props.filterKey || 'global')
    }
  }
}

const reduxComponent = reduxConnect(mapStateToProps, mapDispatchToProps)(SortingSelect)

export default withTranslation('user')(reduxComponent)
